import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, ElementRef, HostListener, Inject, Input, PLATFORM_ID, QueryList, ViewChildren } from '@angular/core';
import { CommonModule } from '@angular/common';
interface Benefit {
    videoUrl: string;
    title: string;
    description: string;
}

@Component({
    selector: 'app-benefits-section',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './benefits-section.component.html',
    styleUrls: ['./benefits-section.component.scss']
})
export class BenefitsSectionComponent {

    public isBrowser: boolean;
    @ViewChildren('videoPlay') videos!: QueryList<ElementRef<HTMLVideoElement>>;

    benefits: Benefit[] = [
        {
            videoUrl: 'https://cdn.cosmicjs.com/5ac27910-5a85-11f0-ae5a-0f56aa053fcd-bullseye-video.mp4?auto=format,compress',
            title: 'Accuracy',
            description: 'Our AI football prediction model is trained on thousands of historical game scenarios. It spots patterns, inefficiencies and market edges that humans miss.',
        },
        {
            videoUrl: 'https://cdn.cosmicjs.com/5a3d1c70-5a85-11f0-ae5a-0f56aa053fcd-2-1.mp4?auto=format,compress',
            title: 'Time-saving',
            description: 'Forget combing through every CFB matchup. Dimers Platinum filters out the noise and serves up only the most actionable opportunities—every week, no fluff.',
        },
        {
            videoUrl: 'https://cdn.cosmicjs.com/55144f70-5a85-11f0-ae5a-0f56aa053fcd-3.mp4?auto=format,compress',
            title: 'Easy to use',
            description: 'You don’t need to know machine learning. Picks are delivered with the best available lines and a full track record. It’s AI sports betting made simple.',
        },
    ];

    constructor(@Inject(PLATFORM_ID) private platformId: Object) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent) {
        if (this.videos) {
            this.videos.forEach(item => {
                if(item.nativeElement.paused){
                    item.nativeElement.play().catch(e => console.error('video still not playing', e));
                }
            });
        }
    }
}
